import { loadWithChunkRetry } from '@muse-web/router'

import type { resolveBillingRedirect } from './resolveBillingRedirect'
import type { resolveSetupIntentRedirect } from './resolveSetupIntentRedirect'

type TSetupIntentRedirectParams = Parameters<typeof resolveSetupIntentRedirect>[0]

type TBillingRedirectParams = Parameters<typeof resolveBillingRedirect>[0]

export const resolveSetupIntentRedirectAsync = (params: TSetupIntentRedirectParams) =>
    loadWithChunkRetry(
        () => import(/* webpackChunkName: 'checkout-redirect' */ './resolveSetupIntentRedirect'),
    ).then(module => module.resolveSetupIntentRedirect(params))

export const resolveBillingRedirectAsync = (params: TBillingRedirectParams) =>
    loadWithChunkRetry(
        () => import(/* webpackChunkName: 'checkout-redirect' */ './resolveBillingRedirect'),
    ).then(module => module.resolveBillingRedirect(params))
